// extracted by mini-css-extract-plugin
export default {"timer":"VotingTimerView_timer__+R-mz","timerText":"VotingTimerView_timerText__uZzR+"};